'use strict';

// Keeps the header solid (white) while mega menu or search drawer is open at scroll-top.
(() => {
  const header = document.querySelector('.header-main');
  if (!header) return;

  const body = document.body;
  let megaMenuOpen = false;

  const isAtTop = () =>
    (window.pageYOffset || document.documentElement.scrollTop || 0) <= 0;

  const setSolidHeader = () => {
    header.classList.remove('transluscent');
  };

  const setTransparentHeader = () => {
    if (!isAtTop()) return;
    if (body.classList.contains('drawer-open')) return;
    if (body.classList.contains('drawer-search-open')) return;
    if (megaMenuOpen) return;

    header.classList.add('transluscent');
  };

  header.querySelectorAll('.header-main__menu .menu-main__mega').forEach((item) => {
    if (!item.querySelector('.menu-main__container--mega')) return;

    item.addEventListener('mouseenter', () => {
      megaMenuOpen = true;
      setSolidHeader();
    });

    item.addEventListener('mouseleave', () => {
      megaMenuOpen = false;
      setTransparentHeader();
    });
  });

  const onBodyClassChange = () => {
    if (body.classList.contains('drawer-search-open')) {
      setSolidHeader();
    } else {
      setTransparentHeader();
    }
  };

  new MutationObserver(onBodyClassChange).observe(body, {
    attributes: true,
    attributeFilter: ['class'],
  });

  onBodyClassChange();
})();
